import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { InvoiceImportCostLayersPayload } from 'src/app/models/invoice-import.model';
import { InvoiceImportService } from 'src/app/services/invoice-import.service';
import { costLayerSourceKey, formatKrPlain, translateInstant } from 'src/app/services/invoice-import.util';

@Component({
  selector: 'app-invoice-cost-layers-dialog',
  templateUrl: './invoice-cost-layers-dialog.component.html',
  styleUrls: ['./invoice-cost-layers-dialog.component.scss'],
})
export class InvoiceCostLayersDialogComponent implements OnInit {
  @Input() storeId!: string;
  @Input() productId!: string;
  @Input() productName = '';

  payload: InvoiceImportCostLayersPayload | null = null;
  loadError = '';

  constructor(
    protected ref: NbDialogRef<InvoiceCostLayersDialogComponent>,
    private invoiceImportService: InvoiceImportService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loadError = '';
    this.spinner.show();
    this.invoiceImportService.getProductCostLayers(this.storeId, this.productId).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        this.payload = res.response?.data || res.data || null;
      },
      error: (err: any) => {
        this.spinner.hide();
        this.loadError = err.error?.response?.message || err.message;
      },
    });
  }

  close(): void {
    this.ref.close();
  }

  formatKr = formatKrPlain;

  layerSourceLabel(source: string | undefined): string {
    const key = costLayerSourceKey(source);
    return key ? translateInstant(this.translate, key) : source || '—';
  }

  costPriceSourceLabel(): string {
    const src = this.payload?.costPriceSource;
    if (!src) {
      return '—';
    }
    return translateInstant(this.translate, `INVOICE_IMPORTS.PHASE2.COST_PRICE_SOURCE.${String(src).toUpperCase()}`);
  }
}
